import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Image, Heading, IconButton, Input, Text, HStack, Stack, Accordion, Span, For } from '@chakra-ui/react'
import logo from '../../shared/assets/logo.png'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { CiLogout } from "react-icons/ci";
import { FaUser } from "react-icons/fa";
import { LuLayoutGrid } from "react-icons/lu";
import { FaDisplay, FaU } from "react-icons/fa6";
import { BsCollectionPlay } from "react-icons/bs";
import Tree from './Tree.jsx'





const DVSidebar = () => {
    const navigate = useNavigate();
    const [isDisplayOpen, setIsDisplayOpen] = useState(false)
    const [isPlaylistOpen, setIsPlaylistOpen] = useState(false)

    const navToDash = () => {
        navigate('/Dashboard/Landing');
    }

    const navToOnboard = () => {
        navigate('/')
    }

    const handleDisplayOpen = () =>{
        setIsDisplayOpen(!isDisplayOpen)
    }

    const handlePlaylistOpen = () =>{
        setIsPlaylistOpen(!isPlaylistOpen)
    }

    const node0 = [
        {
          type: "file",
          id: 0,
          name: "Nodes0",
          root: "node",
          children: []
        },
    ]

    const node1 = [
        {
          type: "file",
          id: 1,
          name: "Nodes1",
          root: "node",
          children: []
        },
    ]
    const node2 = [
        {
          type: "dir",
          id: 2,
          name: "Nodes2",
          root: "node",
          children: [node1, node0]
        },
    ]
    
    const node3 = [
        {
          type: "dir",
          id: -1,
          name: "Nodes3",
          root: "node",
          children: [node2]
        },
    ]
    const node4 = [
        {
          type: "dir",
          id: -1,
          name: "Nodes4",
          root: "node",
          children: [node2]
        },
    ]
    
    const master = [
        {
          type: "dir",
          id: -1,
          name: "master",
          root: "node",
          children: [node3, node4]
        },
    ]


    //backend logout
    const logout = () => {
        const url = new URL('/api/auth/logout', window.location.origin);
        const sessionToken = localStorage.getItem('sessionToken')

        fetch(url, {
            method: 'POST',
            headers: { 
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(sessionToken)
        })
        .then(response => {
            if (!response.ok){
                if (response.status == 405){
                    throw new Error ("Wrong header")
                }
                else if (response.status == 406){
                    throw new Error ("Token expired")
                }
                else if (response.status == 500){
                    throw new Error ("Failed to logout backend")
                }
                else {
                    throw new Error ("Error logging out");
                }
            }

            return response.json();
        })
        .then(data => {
            navToOnboard()
        })
        .catch(error => {
            console.log(error.message)
        });
    }
    
    

  return (
    <Box h={'full'} w={'1/6'} as={'aside'} pos={'fixed'} overflowY={'scroll'} overflowX={'scroll'} bgColor={'#011936'}>
            <Stack gap={16} padding={6} bg={'gray.600'} h={'full'} align={'center'} bgColor={'#011936'}>
                <Image src={logo} htmlHeight={"120px"} htmlWidth={"120px"} onClick={navToDash} _hover={{cursor: 'pointer'}}/>
                <Stack   color={'white'} fontSize={20} fontFamily={'Esteban'} gap={6} w={'3/4'} h={'3/4'} overflow={'scroll'}>
                    <Flex justifyContent={'space-between'} align={'center'} cursor={'pointer'} _hover={{color: '#465362'}} borderBottom={'2px solid #465362'}
                        onClick={navToDash}>
                        <LuLayoutGrid />
                        <Text fontFamily={'body'}>Dashboard</Text>
                    </Flex>
                    <Flex justifyContent={'space-between'} align={'center'} cursor={'pointer'} _hover={{color: '#465362'}} borderBottom={'2px solid #465362'}>
                        <FaUser />
                        <Text fontFamily={'body'}>Users</Text>
                    </Flex>
                    <Flex justifyContent={'space-between'} align={'center'} cursor={'pointer'} _hover={{color: '#465362'}}
                        onClick={handleDisplayOpen} borderBottom={'2px solid #465362'}>
                        <FaDisplay />
                        <Text fontFamily={'body'}>Displays</Text>
                    </Flex>
                    {isDisplayOpen && (<Tree data={master}/>)}
                    <Flex justifyContent={'space-between'} align={'center'} cursor={'pointer'} _hover={{color: '#465362'}}
                        onClick={handlePlaylistOpen} borderBottom={'2px solid #465362'}>
                        <BsCollectionPlay />
                        <Text fontFamily={'body'}>Playlists</Text>
                    </Flex>
                    {isPlaylistOpen && (<Tree data={master}/>)}
                </Stack>
                    <Link>
                        <HStack align={'center'} justifyContent={'flex-end'} cursor={'pointer'} _hover={{color: '#465362'}} color={'white'} onClick={logout}>
                            <CiLogout />
                            <Text fontFamily={'body'}>
                                Logout
                            </Text>
                        </HStack>
                    </Link>
            </Stack>
    </Box>
  )
}

export default DVSidebar
